import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=20f84526&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=20f84526&prod&scoped=true&lang=css"
import style1 from "./Login.vue?vue&type=style&index=1&id=20f84526&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f84526",
  null
  
)

export default component.exports